var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c(
        "gg-card-text",
        {
          staticClass: "pa-3"
        },
        [
          _c(
            "div",
            {
              staticClass: "kvm-coming text-center py-10"
            },
            [
              _c(
                "v-icon",
                {
                  staticClass: "mb-3",
                  attrs: {
                    size: "56",
                    color: "primary",
                    "aria-hidden": "true"
                  }
                },
                [_vm._v("mdi-dns")]
              ),
              _c(
                "h2",
                {
                  staticClass: "kvm-coming__heading mb-2"
                },
                [_vm._v("Reverse DNS — coming soon")]
              ),
              _c(
                "p",
                {
                  staticClass: "kvm-coming__text mb-0 mx-auto"
                },
                [
                  _vm._v(
                    " Setting the PTR record for your server's IP addresses isn't available yet. We're working on bringing it to your dashboard. "
                  )
                ]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }